import * as React from "react";
import Button from "@mui/material/Button";
import { SxProps, Theme, styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX } from "@fortawesome/free-solid-svg-icons";

export const CustomDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
  sx?: SxProps<Theme> | undefined;
}

export function DialogHeader(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ mr: 4, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <FontAwesomeIcon icon={faX} size="sm" />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

export default function PasswordRecoveryModal(props: {
  email: string;
  open: boolean;
  setOpen: (showModal: boolean) => void;
}) {
  const { email, open, setOpen } = props;

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <CustomDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogHeader id="customized-dialog-title" onClose={handleClose}>
        Email enviado com sucesso!
      </DialogHeader>
      <DialogContent dividers>
        <div style={{ margin: "20px" }}>
          <Typography gutterBottom>
            Um email de verificação foi enviado para <strong>{email}</strong>.
          </Typography>
          <Typography gutterBottom>
            Por favor, verifique sua caixa de entrada.
          </Typography>
        </div>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleClose}>
          Fechar
        </Button>
      </DialogActions>
    </CustomDialog>
  );
}
